import { memo } from 'react';

import { useActivitySession } from '@common/hooks/use-activity-session';
import { useAppSelector } from '@hooks/redux';
import * as userSelector from '@modules/core/selectors/logged-user';
import * as organisationSelector from '@modules/organisation/selectors/organisation';

function ActivitySessionTracker() {
  const organisation = useAppSelector(organisationSelector.selected);
  const loggedUser = useAppSelector(userSelector.selected);
  const initialised = useAppSelector((state) => state.app.organisationInitialised);

  useActivitySession({
    organisationId: organisation?.id,
    enabled: Boolean(initialised && loggedUser && organisation?.id),
  });

  return null;
}

export default memo(ActivitySessionTracker);
